(function () {
  function parseTiers(tiersStr) {
    return (tiersStr || "")
      .split("|")
      .map((x) => x.split(":"))
      .filter((p) => p.length === 2)
      .map(([q, p]) => ({ min: Number(q), pct: Number(p) }))
      .filter((t) => Number.isFinite(t.min) && Number.isFinite(t.pct))
      .sort((a, b) => a.min - b.min);
  }

function getQtyForChart(chartEl) {
  // Find the closest PDP section that contains both chart + quantity
  const root =
    chartEl.closest('product-info') ||
    chartEl.closest('[data-section]') ||
    document;

  // Dawn quantity input on PDP is usually: input.quantity__input[name="quantity"]
  const input =
    root.querySelector('input.quantity__input[name="quantity"]') ||
    root.querySelector('input[name="quantity"]');

  const v = input ? Number(input.value) : 1;
  return Number.isFinite(v) && v > 0 ? v : 1;
}


  function updateChart(chartEl) {
    const sectionId = chartEl.getAttribute("data-section-id");
    const tiers = parseTiers(chartEl.getAttribute("data-tiers"));
    if (!tiers.length) return;

    const qty = getQtyForSection(chartEl);
    let active = null;
    for (const t of tiers) if (qty >= t.min) active = t;

    // highlight active row
    chartEl.querySelectorAll("[data-tier-row]").forEach((row) => {
      const min = Number(row.getAttribute("data-min"));
      row.classList.toggle("is-active", active && min === active.min);
    });

    // note text
    const note = chartEl.querySelector("[data-tier-note]");
    if (note) {
      if (active) {
        note.textContent = `At ${qty} you qualify for ${active.pct}% off.`;
      } else {
        note.textContent = `Add more to unlock volume discounts.`;
      }
    }
  }

  function wireUp(root) {
    const charts = (root || document).querySelectorAll("[data-volume-tier-chart]");
    charts.forEach((chart) => updateChart(chart));
  }

  // Qty changes
  document.addEventListener("input", (e) => {
    const input = e.target;
    if (!input || !input.id || !input.id.startsWith("Quantity-")) return;
    document.querySelectorAll("[data-volume-tier-chart]").forEach((chart) => updateChart(chart));
  });

  // Dawn variant changes often trigger a re-render; easiest is: re-scan after any "variant:change"
  document.addEventListener("variant:change", () => wireUp(document));

  // Also re-scan after any cart/pdp section re-render (safe + cheap)
  const mo = new MutationObserver(() => wireUp(document));
  mo.observe(document.documentElement, { subtree: true, childList: true });

  // initial
  document.addEventListener("DOMContentLoaded", () => wireUp(document));
})();

document.addEventListener("click", (e) => {
  const btn = e.target.closest(".quantity__button");
  if (!btn) return;
  document.querySelectorAll("[data-volume-tier-chart]").forEach((chart) => updateChart(chart));
});
